import { Stack } from '@bedrock-layout/stack';
import styled from 'styled-components';

export const ErrorContainer = styled(Stack)`
  align-items: center;
  margin-top: 2rem;
`;
